import {UseFormReturn} from 'react-hook-form';

import {VehicleSelectionFormBinding} from '../../../types/VehicleSelectionFormBinding';
import {WatermarkFormType} from '../types/WatermarkFormType';

export const getWatermarkVehicleSelectionBinding = (
  formApi: UseFormReturn<WatermarkFormType>
): VehicleSelectionFormBinding<WatermarkFormType> => ({
  getListFieldName: (field) => `filter.${field}`,
  getNumberFieldName: (field) => `filter.${field}`,
  getTextFieldName: (field) => `filter.${field}`,
  setListFieldValue: (field, value, options) => formApi.setValue(`filter.${field}`, value, options),
  setTextFieldValue: (field, value, options) => formApi.setValue(`filter.${field}`, value, options),
});
